import { StoreType } from '@tock/shared/utils/connect';
import { googleAnalyticsScriptsLoadedSelector } from 'selectors/cookieConsentSelectors';
import { useSelector } from 'react-redux';
import _ from 'lodash';

interface Options {
  skipRegisterExperiment: boolean;
}

export const useExperimentVariant = (experimentName: string, options?: Options) => {
  const experiments = useSelector((state: StoreType) => state.experiments);
  const isGaScriptLoaded = useSelector(googleAnalyticsScriptsLoadedSelector);
  const experimentMatch = experiments.variants[experimentName];

  if (_.isNil(experimentMatch?.variant)) {
    return;
  }

  // Don't set the experiment until after we're sure that GA scripts have been loaded.
  // This prevents an experiment from prematurely being added to the "addedExperiments" set.
  if (!options?.skipRegisterExperiment && isGaScriptLoaded) {
    window?.analytics?.setExperiment(`${experimentMatch.id}.${experimentMatch.variant}`);
  }

  return experimentMatch.variant;
};
